import NiceModal from "@ebay/nice-modal-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Complete() {
    const location = useLocation();

    useEffect(() => {
        // NiceModal.show("paymentComplete", { storeCode: location.state && location.state.storeCode });
    }, [])
    return (
        <div>{`데모용 결제 페이지\n결제가 완료되었습니다.`}</div>
    );
}

export default Complete;